module.exports = __webpack_public_path__ + "static/media/phone.1fbaa49d.svg";